import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cumplimiento-ley',
  templateUrl: './cumplimiento-ley.component.html',
  styleUrls: ['./cumplimiento-ley.component.css']
})
export class CumplimientoLeyComponent implements OnInit {

  quotaForm: FormGroup;
  calculatedQuota: any = null;
  lastUpdate = '25 de junio de 2025';

  // Tabla de obligaciones
  obligaciones = [
    {
      rango: '50-99 empleados',
      cuota: 'Mínimo 1 persona',
      plazo: 'Obligatorio desde 25/06/2026',
      documentacion: 'Certificación de discapacidad, reporte MinTrabajo'
    },
    {
      rango: '100-500 empleados',
      cuota: '2 por cada 100 (2%)',
      plazo: 'Obligatorio desde 25/06/2026',
      documentacion: 'Certificación de discapacidad, reporte MinTrabajo'
    },
    {
      rango: '501+ empleados',
      cuota: '2 por cada 100 + 1 adicional por cada 100 posteriores',
      plazo: 'Obligatorio desde 25/06/2026',
      documentacion: 'Certificación de discapacidad, reporte MinTrabajo'
    }
  ];

  // FAQ Legal
  faqLegal = [
    {
      pregunta: '¿Cuál es la cuota mínima para mi empresa?',
      respuesta: 'La cuota mínima es de 1 persona con discapacidad certificada para empresas con 50-99 empleados. Para empresas más grandes, la cuota se calcula proporcionalmente.',
      expanded: false
    },
    {
      pregunta: '¿Qué es la certificación de discapacidad?',
      respuesta: 'Es un documento emitido por el Ministerio de Salud que acredita la condición de discapacidad de una persona. Es requisito obligatorio para el cumplimiento de la ley.',
      expanded: false
    },
    {
      pregunta: '¿Qué son los ajustes razonables?',
      respuesta: 'Son las modificaciones y adaptaciones necesarias para garantizar que las personas con discapacidad puedan desempeñar sus funciones en igualdad de condiciones.',
      expanded: false
    },
    {
      pregunta: '¿Cómo se reporta al MinTrabajo?',
      respuesta: 'Debes reportar los contratos celebrados con personas con discapacidad dentro de los 15 días siguientes a la contratación, a través del sistema oficial del Ministerio.',
      expanded: false
    },
    {
      pregunta: '¿Existe pago sustitutivo?',
      respuesta: 'No. La Ley 2466 no contempla pago sustitutivo. La obligación es vincular personas con discapacidad o evidenciar búsqueda seria.',
      expanded: false
    }
  ];

  // Recursos descargables
  recursosDescargables = [
    {
      titulo: 'Checklist de Cumplimiento',
      descripcion: 'Lista de verificación paso a paso para cumplir la Ley 2466',
      formato: 'PDF',
      icono: 'fas fa-check-square',
      descarga: '#'
    },
    {
      titulo: 'Formato de Reporte Interno',
      descripcion: 'Plantilla para el reporte interno de contrataciones',
      formato: 'Word',
      icono: 'fas fa-file-alt',
      descarga: '#'
    },
    {
      titulo: 'Guía de Ajustes Razonables',
      descripcion: 'Manual completo de implementación de ajustes razonables',
      formato: 'PDF',
      icono: 'fas fa-tools',
      descarga: '#'
    },
    {
      titulo: 'Guía de Certificación',
      descripcion: 'Proceso completo para obtener certificación de discapacidad',
      formato: 'PDF',
      icono: 'fas fa-certificate',
      descarga: '#'
    }
  ];

  constructor(private fb: FormBuilder, private router: Router) {
    this.quotaForm = this.fb.group({
      employees: ['', [Validators.required, Validators.min(50)]]
    });
  }

  ngOnInit(): void {
  }

  calculateQuota(): void {
    if (this.quotaForm.valid) {
      const employeesControl = this.quotaForm.get('employees');
      const employees = employeesControl ? employeesControl.value : 0;
      let quota = 0;
      let description = '';
      let plazo = '';

      if (employees >= 50 && employees <= 99) {
        quota = 1;
        description = 'Mínimo 1 persona con discapacidad certificada';
        plazo = 'Obligatorio desde 25/06/2026';
      } else if (employees >= 100 && employees <= 500) {
        quota = Math.ceil(employees / 100) * 2;
        description = '2 por cada 100 empleados (equivale a 2%)';
        plazo = 'Obligatorio desde 25/06/2026';
      } else if (employees > 500) {
        quota = Math.ceil(employees / 100) * 2 + Math.floor((employees - 500) / 100);
        description = '2 por cada 100 + 1 adicional por cada 100 posteriores a 500';
        plazo = 'Obligatorio desde 25/06/2026';
      }

      this.calculatedQuota = {
        employees: employees,
        quota: quota,
        description: description,
        plazo: plazo
      };
    }
  }

  toggleFaq(index: number): void {
    this.faqLegal[index].expanded = !this.faqLegal[index].expanded;
  }

  downloadResource(recurso: any): void {
    console.log('Redirigiendo a contacto para descargar:', recurso.titulo);
    this.router.navigate(['/contacto']);
  }

  agendarDiagnostico(): void {
    console.log('Redirigiendo a contacto para agendar diagnóstico');
    this.router.navigate(['/contacto']);
  }
}
